module.exports = __webpack_public_path__ + "components/panel/ski-bro/static/swiss@3-3c97aa3ea8d85d942c0de30636d752ab.jpg";